//export const URL = 'http://localhost:4000/';
export const URL = 'https://final-task-backend-production-f46a.up.railway.app/';
